import { Grid, Typography, Button } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import User from "./User";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import CounterType from "./CounterType";
import Loading6 from "../../assets/loading/loading6.gif";
import Counter from "./Counter";
import categoryCounters from "./ListOneCategoryCounters";
import { useDispatch } from "react-redux";

import {
  BLACK,
  BLUE_COLOR,
  DARK_SIDEBAR,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  usersPageSize, // for pagination
  SILVER_TABLE_COLOR,
  WHITE,
} from "../../utils/const";
import moment from "jalali-moment";
import Call from "../../service/API";

import ReactExport from "react-export-excel";

import CategoricalCounters from "./ListCategoricalCounters";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ListCounters = (props) => {
  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.categories);
  let reverse_categories = [...categories].filter(
    (category) => category.id !== "4f7205f0-c8a7-4fb1-a450-0c6622d4f364"
  );
  reverse_categories.reverse();

  const thisProjectCounters = useCustomState([]);

  const consumptions = useCustomState({});
  const consumptionIsLoading = useCustomState(true);

  useEffect(() => {
    if (!props.isLoading.value) {
      thisProjectCounters.handleChange(processCounters(props.counters));
    }
  }, [props.isLoading.value]);

  const sheetData = useCustomState([]);

  useEffect(() => {
    const results = [];
    if (
      !props.isLoading.value &&
      !consumptionIsLoading.value &&
      thisProjectCounters.value.length > 0
    ) {
      thisProjectCounters.value.map((c, idx) => {
        const consInfo = consumptions.value[c.serial];
        let total, lastDate, lastValue, monthValue;
        if (consInfo !== undefined) {
          total = consInfo.total_value ? consInfo.total_value : 0;
          lastDate = consInfo.last_consumption
            ? moment(consInfo.last_consumption.create_time)
                .locale("fa")
                .format("YYYY/MM/DD HH:mm:ss")
            : "ثبت نشده";
          lastValue = consInfo.last_consumption
            ? consInfo.last_consumption.value
            : 0;
          monthValue = consInfo.cumulative_consumptions
            ? consInfo.cumulative_consumptions.month[1]
            : 0;
        } else {
          total = 0;
          lastDate = "ثبت نشده";
          lastValue = 0;
          monthValue = 0;
        }
        const data = {
          ...c,
          index: idx,
          total: total,
          lastDate: lastDate,
          lastValue: lastValue,
          monthValue: monthValue,
        };
        results.push(data);
      });
      sheetData.handleChange(results);
    }
  }, [
    props.isLoading.value,
    consumptionIsLoading.value,
    thisProjectCounters.value,
  ]);

  const renderCardView = (counters) => {
    return counters.map((counter, idx) => {
      return <Counter data={counter} key={idx} index={idx} />;
    });
  };

  const renderExcel = () => {
    if (!props.isLoading.value && !consumptionIsLoading.value) {
      // console.log("sheet Data: ", sheetData.value);
      return (
        <ExcelFile
          filename={"کنتورهای_پروژه"}
          element={
            <Button style={{ backgroundColor: GREEN_PRIMRY, color: WHITE }}>
              دانلود فایل اکسل
            </Button>
          }
        >
          <ExcelSheet data={sheetData.value} name="اطلاعات_کنتورها">
            <ExcelColumn label="#" value="index" />
            <ExcelColumn
              style={{ font: { bold: true } }}
              label="نام کنتور"
              value="name"
            />
            <ExcelColumn label="شماره سریال" value="serial" />
            <ExcelColumn
              label="تاریخ ثبت"
              value={(col) =>
                moment(col.date).locale("fa").format("YYYY/MM/DD")
              }
            />
            <ExcelColumn label="دسته" value="category" />
            <ExcelColumn label="نوع کنتور" value="type" />
            <ExcelColumn
              label="وضعیت فعالیت"
              value={(col) => (col.validation ? "فعال" : "غیرفعال")}
            />
            <ExcelColumn
              label="وضعیت فروش"
              value={(col) => (col.activation ? "فروخته شده" : "فروخته نشده")}
            />
            <ExcelColumn
              label="مالک"
              value={(col) =>
                col.username ? col.username + " " + col.userLastname : "--"
              }
            />
            <ExcelColumn label="تاریخ ثبت آخرین مصرف" value="lastDate" />
            <ExcelColumn label="آخرین مقدار مصرف" value="lastValue" />
            <ExcelColumn label="مقدار مصرف ماه جاری" value="monthValue" />
            <ExcelColumn label="مقدار کل مصرف" value="total" />
          </ExcelSheet>
        </ExcelFile>
      );
    } else {
      return null;
    }
  };

  const renderContent = () => {
    if (props.isLoading.value) {
      return (
        <Grid container>
          <div
            style={{
              width: "100%",
              height: "260px",
              marginTop: "48px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              position: "relative",
            }}
          >
            <img
              src={Loading6}
              style={{
                width: "180px",
                height: "180px",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
              alt="Loading..."
            />
          </div>
        </Grid>
      );
    } else {
      return (
        <Grid container>
          {reverse_categories.map((cat, idx) => {
            return (
              <CategoricalCounters
                key={idx}
                counters={thisProjectCounters.value}
                category={cat}
                projectId={props.projectId}
                project={props.project}
              />
            );
          })}
        </Grid>
      );
    }
  };
  return (
    <Grid
      container
      style={{
        paddingRight: "16px",
        paddingLeft: "16px",
        marginBottom: "24px",
      }}
    >
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"کنتورهای این پروژه"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
              }}
            >
              {renderContent()}
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {renderExcel()}
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ListCounters;

const processCounters = (counters) => {
  // console.log("***********counters: ", counters);
  const results = [];
  let data;
  counters.map((counter) => {
    data = {
      name: counter.water_meter_name,
      date: counter.water_meter_create_date,
      serial: counter.water_meter_serial,
      type: counter.water_meter_type_info.water_meter_type_name,
      category: counter.water_meter_tag_info.water_meter_tag_name,
      project: counter.water_meter_project_info.project_name,
      validation: counter.water_meter_validation,
      activation: counter.water_meter_activation,
      categoryId: counter.water_meter_tag_info.water_meter_tag_id,
      username: counter.water_meter_user_info.user_name,
      userLastname: counter.water_meter_user_info.user_lastname,
      consumptionInfo: {
        // total: counter.cumulative_consumptions.year,
        // month: counter.cumulative_consumptions.month,
        // last: counter.last_consumption ? counter.last_consumption.value : 0,
        // lastDate: counter.last_consumption
        //   ? counter.last_consumption.create_time
        //   : null,
        total: null,
        month: null,
        last: counter.last_consumption ? counter.last_consumption.value : 0,
        lastDate: counter.last_consumption
          ? counter.last_consumption.create_time
          : null,
      },
    };
    results.push(data);
  });
  return results;
};

const processConsumptions = (consumptions) => {
  const processedConsumptions = [];
  // console.log("pure consumptions: ", consumptions);
  consumptions.map((c, idx) => {
    const data = {
      serial: c.water_meter_serial,
      lastData: {
        date: c.last_consumption ? c.last_consumption.create_time : null,
      },
      consumptionData: {
        total: 0,
        month: 0,
        day: 0,
        year: 0,
      },
    };
    processedConsumptions.push(data);
  });
  // console.log("processed consumptions: ", processedConsumptions);
  return processedConsumptions;
};

const fetchConsumption = (utils) => {
  const isLoading = utils.isLoading;
  const info = utils.consumptionInfo;
  const page = utils.page;
  const count = utils.count;
  const projectId = utils.projectId;

  const data = {
    page: page,
    count: count,
    project_id: projectId,
  };

  Call("POST", "watermeters/admin/cumulative/consumption", data)
    .then((response) => {
      if (response.data.code === 200) {
        const consumptionInfo = response.data.data;
        if (consumptionInfo.length > 0) {
          // console.log("consumption info: ", consumptionInfo);
          info.handleChange({});
        } else {
          info.handleChange({});
        }
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
    });
};
